import {
  withTranslation,
} from 'react-i18next';

import AdminBannersPageView from './AdminBannersPageView';

const TranslatedComponent = withTranslation()(AdminBannersPageView);

const Component = TranslatedComponent;

export default Component;
